import React from 'react';
import PropTypes from 'prop-types';
import template from '../../../../templates/Stones/AssignPricing/PricingPresets/footer.rt';
import { connect } from 'react-redux';
import * as pricingPresetPages from '../../../../constants/pricingPresets';
import * as actions from '../../../../actions';
import {AccessRights} from './../../../../schemas/accessRightsModel';

function mapStateToProps(state, props) {
  let deleteVisible = false,
    selectVisible = false,
    algorithmButtons = false;
  const { page } = state.pricingPreset;
  switch (page) {
    case pricingPresetPages.PRICING_PRESET_LIST:
      deleteVisible = true;
      selectVisible = true;
      break;
    case pricingPresetPages.PRICING_PRESET_EDIT:
      algorithmButtons = true;
    case pricingPresetPages.PRICING_PRESET_NEW:
      deleteVisible = false;
      selectVisible = false;
      break;
  }
  return {
    deleteVisible,
    selectVisible,
    algorithmButtons,
    page,
    selectedPreset: state.pricingPreset.selectedPreset,
    AR: AccessRights.get(state)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSave: () => dispatch(actions.pricingPresets.save()),
    onCancel: () => dispatch(actions.pricingPresets.show(false)),
    onDelete: () => dispatch(actions.pricingPresets.deletePreset())
  };
}

class footer extends React.Component {
  render = template;

  /**
   * handles Save event
   */
  onSave = () => {
    this.props.onSave()
      .then(() => this.props.toPage(pricingPresetPages.PRICING_PRESET_EDIT))
      .catch(console.error);
  }

  /**
   * handles Select event
   */
  onSelect = () => {
    if (this.props.selectedPreset && this.props.selectedPreset.id > 0) {
      this.props.toPage(pricingPresetPages.PRICING_PRESET_EDIT);
    } else {
      this.props.toPage(pricingPresetPages.PRICING_PRESET_NEW);
    }
  }
}

footer.propTypes = {
  toPage: PropTypes.func.isRequired
};

const Footer = connect(mapStateToProps, mapDispatchToProps)(footer);

export default Footer;
